import { render, staticRenderFns } from "./FormLoyaltySettings.vue?vue&type=template&id=39fb6700&"
import script from "./FormLoyaltySettings.vue?vue&type=script&lang=js&"
export * from "./FormLoyaltySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports